export default "__VITE_ASSET__hKROalWF__"